import { useSuspenseQuery } from "@tanstack/react-query";

import { ReactQueryKeysGlobal } from "../queryKeys";
import { getNetworkPolicies } from "./getNetworkPolicies";

export const useNetworkPolicies = () => {
  const { data } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.networkPolicies],
    queryFn: getNetworkPolicies,
    retry: false,
  });
  return data || [];
};
